var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "10px",
    viewBox: "0 0 9 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iteraties",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager---Verlof-en-absenties---Kalender-Iteratie-Jop",
    transform: "translate(-601.000000, -439.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(594.000000, 429.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "black-male-user-symbol",
    transform: "translate(0.580357, 0.312500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4196429,17.72545 L15.3834873,17.7631401 C14.1930955,19.00388 12.6074857,19.6875 10.9196429,19.6875 C9.23155065,19.6875 7.64619021,19.0040966 6.4555491,17.7631401 L6.41964286,17.72545 L6.42812072,17.6771461 C6.65802043,16.3744558 7.44147474,15.3280147 8.63411064,14.7299555 L8.71888927,14.6875 L8.78646283,14.7490171 C9.34974204,15.2623819 10.1072641,15.5448409 10.9193935,15.5448409 C11.7315229,15.5448409 12.489045,15.2621653 13.0523242,14.7490171 L13.1198977,14.6875 L13.2046764,14.7299555 C14.3973123,15.3280147 15.1807666,16.3744558 15.4109156,17.6771461 L15.4196429,17.72545 Z M10.9196429,14.6875 C12.2980866,14.6875 13.4196429,13.565996 13.4196429,12.1876163 C13.4196429,10.8092367 12.2980866,9.6875 10.9196429,9.6875 C9.54119907,9.6875 8.41964286,10.8092367 8.41964286,12.1873837 C8.41964286,13.5655306 9.54119907,14.6875 10.9196429,14.6875 Z",
    id: "Shape-Copy"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlack);
export default __webpack_public_path__ + "static/media/person-black.25bc6f6cc98bc90d864af966d72fed18.svg";
export { ForwardRef as ReactComponent };